export default __webpack_public_path__ + "static/media/ShaiLee.956e1730.jpeg";